export const MICROFRONTEND_PATH = {
  v1: '/v1/get-desktop-filters-microfrontend/',
};
